
import { User } from "@supabase/supabase-js";

export const useImpersonationInitializer = (
  setIsImpersonating: (value: boolean) => void,
  setOriginalUser: (user: User | null) => void
) => {
  const initializeImpersonation = () => {
    const impersonationData = localStorage.getItem('impersonation');
    if (impersonationData) {
      try {
        const { isImpersonating: savedIsImpersonating, originalUser: savedOriginalUser } = JSON.parse(impersonationData);
        setIsImpersonating(savedIsImpersonating);
        setOriginalUser(savedOriginalUser);
      } catch (e) {
        localStorage.removeItem('impersonation');
      }
    }
  };

  return {
    initializeImpersonation
  };
};
